<template>
    <div>
        <header id="header">
            <div class="inner">
              <div class="col col1">
                  <a class="btnNavi prev">
                      <span @click.stop.prevent="backBtn" class="ico">이전</span>
                  </a>
              </div>
              <div class="col col2">
                  <!-- 마이페이지, 주문내역 -->
                <h1>{{ $t('MainPage.merchantInformation') }}</h1>
              </div>
              <a class='btnNavi sch'>
                <span @click.stop.prevent='moveToSearchPage' class='ico'>검색</span>
              </a>
              <a class='btnNavi home' @click="appMoveMain()">
                  <span class='ico'>홈</span>
              </a>
              <a class='btnNavi all-menu' @click='allMenuToggleEmit'>
                <span class='ico'>메뉴</span>
              </a>
            </div>
        </header>

        <div class="franchise-detail">
            <div class="header">
                <div class="store-name">
                    {{ storeInfo?.name }}
                </div>
            </div>
            <div class="section">
                <div class="info-row" v-if="storeInfo?.marketName">
                    <span class="info-label">{{ $t('marketAffiliation') }}</span>
                    <span class="info-value break-all">{{ storeInfo?.marketName }}</span>
                </div>
                <div class="info-row" v-if="storeInfo?.opTimeDesc">
                    <span class="info-label">{{ $t('MainPage.businessHours') }}</span>
                    <span class="info-value pre-line" >{{ storeInfo?.opTimeDesc }}</span>
                </div>
                <div class="info-row" v-if="storeInfo?.holidayDesc">
                    <span class="info-label">{{ $t('MainPage.closeDays')}}</span>
                    <span class="info-value">{{ storeInfo?.holidayDesc }}</span>
                </div>
                <div class="info-row" v-if="storeInfo?.address">
                    <span class="info-label">{{ $t('MainPage.address')}}</span>
                    <span class="info-value">{{ storeInfo?.address }}</span>
                </div>
                <div class="info-row" v-if="storeInfo?.phone">
                    <span class="info-label">{{ $t('MainPage.phoneNumber')}}</span>
                    <span class="info-value">
                        <a @click.stop.prevent="goMobileDial(storeInfo?.phone)" class="call"><span>{{ $t('Shop.call') }}</span></a>
                    </span>
                </div>
                <!-- <div class="info-row" v-if="storeInfo?.phone">
                    <span class="info-label">연락처</span>
                    <span class="info-value">
                        <p @click="goMobileDial(storeInfo?.phone)" class="call">전화걸기</p>
                    </span>
                </div> -->
                <!-- TODO : 2025-12-10 명동 포장 관련 임시, v-if 절에 && !isTakeOutStoreIncluded(this.$store.getters.currentStoreCode) 만 삭제-->
                <div class="info-row" v-if="storeInfo?.distance && !isTakeOutStoreIncluded(this.$store.getters.currentStoreCode)">
                    <span class="info-label">{{ $t('Shop.location') }}</span>
                    <span class="info-value">
                      <b>{{ $t('Shop.fromMyAddress') }} {{ storeInfo?.distance }}km</b>
                    </span>
                </div>
                <!-- 웹 일때 브라우저 다시 탭 열었을 때 데이터 없으면  kakaomap 안보이도록 처리-->
                <div class="map-container" v-if="isStoreCoordinateValid">
                  <KakaoMap />
                </div>

                <!-- TODO : 2025-12-10 명동 포장 관련 임시, v-if  조건 삭제 -->
                <div class="info-row" v-if="!isTakeOutStoreIncluded(this.$store.getters.currentStoreCode)">
                    <span class="info-label">{{ $t('deliveryAreas') }}</span>
                    <span class="info-value">
                      {{ storeInfo?.deliveryArea }}
                    </span>
                </div>
                <!-- TODO : 2025-12-10 명동 포장 관련 임시, v-if 절에 && !isTakeOutStoreIncluded(this.$store.getters.currentStoreCode) 만 삭제-->
                <div class="info-row" v-if="storeInfo?.deliveryFreeAmount && !isTakeOutStoreIncluded(this.$store.getters.currentStoreCode)">
                    <span class="info-label">{{ $t('amountForFreeDelivery') }}</span>
                    <span class="info-value">{{ `${addPriceUnit(storeInfo?.deliveryFreeAmount)}` }}{{ $t('Shop.minimumAmount') }}</span>
                </div>
                <!-- TODO : 2025-12-10 명동 포장 관련 임시, v-if 절에 && !isTakeOutStoreIncluded(this.$store.getters.currentStoreCode) 만 삭제-->
                <div class="info-row flex-column" v-if="storeInfo?.deliveryAreaList?.length  && !isTakeOutStoreIncluded(this.$store.getters.currentStoreCode)">
                    <span class="info-label">{{ $t('additionalDeliveryFeeByRegion') }}</span>
                    <table class="fee-table">
                      <tbody>
                        <tr v-for="( delivery, i ) in storeInfo?.deliveryAreaList " :key="i">
                          <td>{{ parseArea(delivery.area) }}</td>
                          <td class="price">{{`+${addPriceUnit(delivery.extraFee)}`  }}{{$t('MoneyUnit')}}</td>
                        </tr>
                      </tbody>
                    </table>
                </div>
            </div>
        </div>
        <AppAllMenuPopup
          v-if="allMenuToggle"
          @allMenuToggleEmit="allMenuToggleChange"
        />
    </div>
</template>

<script>
import service from '@/backend/modnpay_app_api'
import KakaoMap from '@/components/Map/KakaoMap.vue'
import { REQ_STORE_INFO } from '@/store/_actions/actionTypes'

export default {
  components: { KakaoMap },
  mounted () {
    this.merchantFlagChange()
  },
  methods: {
    merchantFlagChange () {
      this.$store.dispatch(REQ_STORE_INFO)
    },
    backBtn () {
      this.$router.back()
    },
    addPriceUnit (price) {
      const priceFormat = price ? `${Number(price).toLocaleString()}` : ''
      return priceFormat
    },
    async goMobileDial (phone) {
      if (!phone) return
      const { data } = await service.allocateSafeNumber({ })
      if (data.resultCode !== 0) {
        const msg = data.resultMsg
        this.toast(this, msg)
        return
      }
      const phoneNumber = data.safeNumber.replace(/[^0-9+]/g, '')
      window.location.href = `tel:${phoneNumber}`
    },
    parseArea (areas) {
      if (!(areas && areas.length)) return ''
      return areas.join(', ')
    },
    moveToSearchPage () {
      this.$router.push({
        name: 'SEARCH',
        query: {
          searchType: 0
        }
      })
    },
    allMenuToggleEmit () {
      this.allMenuToggleChange()
    }
  },
  computed: {
    storeInfo () {
      return this.$store.getters.storeInfo
    },
    storeLocation(){
      return this.storeInfo.storeLocation
    },
    isStoreCoordinateValid(){
      return this.storeLocation.latitude && this.storeLocation.longitude
    }
  }
}
</script>

<style scoped>
:root,
body {
    font-size: 10px !important;
    line-height: 1;
}

#header{
    height: 5.6rem;
}

@media (max-width: 359.8px) {

    :root,
    body {
        font-size: 8.75px !important;
    }
}
</style>

<style lang="scss" scoped>
.franchise-detail {
  margin: 0 auto;
  background: white;
  padding: 1.6rem;
  padding-top: 7.2rem;

  .header {
    text-align: center;
    margin-bottom: 1.6rem;
  }

  .store-name {
    font-size: 2rem;
    color: #0d0d0d;
    text-align: left;
    font-weight: bold;
    margin-bottom: 1.6rem;
    line-height: 1.5;
  }

  .section {
    margin-bottom: 3.2rem;
    padding-bottom: 3.2rem;

    &.seller-info {
      border: none;
      margin-bottom: 0;
    }

    .section-title {
      font-weight: bold;
      color: #333;
      padding-top: 0;
      text-align: left;
      font-size: 1.6rem;
    }

    .info-row {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      align-items: flex-start;
      margin-bottom: 1.6rem;
      min-height: 2.4rem;
      gap: 0.8rem;
      &.flex-column {
        flex-direction: column;
      }

      .info-label {
        color: #818181;
        font-size: 1.4rem;
        min-width: 11rem;
        line-height: normal;
      }

      .info-value {
        color: #0d0d0d;
        font-size: 1.4rem;
        font-weight: 500;
        word-break: keep-all;
        line-height: normal;
        .call {
          position: relative;
          display: flex;
          align-items: center;
          &::after {
            background: url("../assets/img/btn-call.svg") no-repeat;
            content: "";
            position: absolute;
            right: -5rem;
            top: 50%;
            transform: translateY(-50%);
            width: 4.4rem;
            height: 3rem;
            margin-left: 10px;
            background-size: 100%;
          }
          &:nth-of-type(n + 2) {
            margin-top: 1.6rem;
          }
          span {
            display: inline-block;
            text-decoration: underline;
          }
        }
      }

      &:last-of-type {
        margin-bottom: 0;
      }
      .fee-table {
        width: 100%;
        border-collapse: collapse; /* 테두리 겹침 제거 */
        table-layout: fixed; /* 균등 너비 계산(줄바꿈 안정) */
        background: #fff;
        font-size: 14px;
        color: #0d0d0d;
      }

      .fee-table td {
        border: 1px solid #dddddd;
        padding: 10px 12px;
        vertical-align: middle;
        line-height: 1.6;
        word-break: keep-all;
      }

      /* 오른쪽 금액 칸 스타일 */
      .fee-table td.price {
        width: 110px;
        white-space: nowrap; /* 금액 줄바꿈 방지 */
        text-align: right; /* 우측 정렬 */
      }
    }

    .map-container {
      width: 100%;
      height: 100%;
      margin-bottom: 1.6rem;
      border: 1px solid #d9d9d9;
    }

    &.store-info,
    &.seller-info {
      text-align: left;

      .section-title {
        padding-bottom: 1.6rem;
      }

      .info-row {
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        margin-bottom: 0.8rem;
        min-height: 2rem;
        gap: 0;

        .info-label {
          font-weight: 500;
          min-width: 4rem;
          font-size: 1.4rem;
        }

        .info-value {
          color: #666;
          font-weight: normal;
          margin-left: 0.4rem;
          font-size: 1.4rem;
        }

        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }

  .buttons {
    display: flex;
    gap: 1rem;
    margin-top: 0;

    .btn {
      flex: 1;
      padding: 1rem 1.6rem;
      border: 1px solid #ddd;
      background: white;
      cursor: pointer;
      font-size: 1.5rem;
      transition: all 0.2s;

      &.btn-primary {
        color: #0d0d0d;
        border: 1px solid #ddd;
      }
    }
  }
}

.label-highlight {
  color: var(--primary) !important;
  font-size: 1.6rem !important;
  font-weight: bold !important;
}

.break-all {
  word-break: break-all !important;
}

.fs-18 {
  font-size: 1.8rem !important;
}
</style>
